<template>
  <component :is="layout"></component>
</template>

<script>
import LoginLayout from "./views/layouts/LoginLayout";
import DashboardLayout from "./views/layouts/DashboardLayout";

import { mapState } from "vuex";

export default {
  components: { LoginLayout, DashboardLayout },
  computed: {
    ...mapState(["layout"])
  }
};
</script>
